<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="mkt-ops -main-font bookprice-dialog-group-book"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Manage customer in book code</md-dialog-title>

      <div class="dialog-content">
        <!-- BLOCK ROW-1 -->
        <div class="md-layout">
          <div class="md-layout-item md-size-15 pr25">
            <div>
              <div class="-label" style="line-height: 3; padding-top: 5px;">
                Book Code
              </div>
              <!-- <div :class="mode === 'ADD' ? 'pt10' : 'pb10'"> -->
              <div class="pt10" style="line-height: 3; padding-top: 0px;">
                {{ bookCode }}
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-80 prl25">
            <div>
              <!-- <div class="-label" style="margin-bottom: 12px;">Description</div> -->
              <!-- <div class="pb10" v-show="mode === 'EDIT'">
                {{ valueDesciption }}
              </div> -->
              <!-- <div
                v-if="mode === 'EDIT'"
                style="line-height: 3; padding-top: 5px;"
              >
                {{ selectedBookType.code + " : " + selectedBookType.title }}
              </div>
              v-else -->
              <div
                class="md-layout-item md-xlarge-size-30 md-large-size-40 md-medium-size-40 md-small-size-40"
              >
                <multiselect
                  v-model="selectedBookType"
                  id="code"
                  label="title"
                  track-by="code"
                  placeholder="Book Type"
                  :open-direction="'bottom'"
                  :options="optionsBookType"
                  :custom-label="customLabel"
                  :searchable="true"
                  :disabled="mode === 'EDIT' ? true : false"
                  :max-height="180"
                  :show-no-results="false"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="''"
                  :hide-selected="true"
                  @select="setDataBookType"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                      <div style="font-family: kanit; padding-top: 3px">
                        {{ option.code + " : " + option.title }}
                      </div>
                      <div
                        class="-delete"
                        v-show="mode !== 'EDIT'"
                        style="padding-top: 2px; margin-right: 8px"
                        @mousedown.prevent.stop="clearAll()"
                      >
                        <i class="material-icons">close</i>
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>

              <div>
                <md-field class="custom-input">
                  <md-input
                    type="text"
                    placeholder="Description..."
                    v-model="valueDesciption"
                    @keypress.native="checkLength"
                  ></md-input>
                </md-field>
              </div>
            </div>
          </div>
          <!-- <div class="md-layout-item md-size-15">
            <div>
              <div class="-label">Head office</div>
              <div class="pt10">{{ headOffice }}</div>
            </div>
          </div> -->
        </div>

        <!-- BLOCK ROW-2 -->
        <div class="md-layout">
          <div
            class="md-layout-item md-size-15 pr25 pt13"
            style="font-size: 14px; font-weight: bold;"
          >
            Customer in group
          </div>
          <div class="md-layout-item md-size-50 prl25">
            <treeselect
              ref="customer"
              class="treeview-box"
              :multiple="true"
              :limit="1"
              :maxHeight="275"
              placeholder="+ Add Customer"
              :async="true"
              :load-options="loadOptions"
              :cache-options="false"
              v-model="valueTree"
              :value-consists-of="valueConsistsOf"
              :clearable="false"
              @select="openOnSelectTreeview"
              @deselect="onDeSelectTreeview"
              @open="onOpenTreeview"
            >
              <label
                slot="option-label"
                slot-scope="{ node }"
                :title="node.label"
                class="nowrap-title"
                >{{ node.id }} : {{ node.label }}</label
              >
            </treeselect>
          </div>
          <div class="md-layout-item md-size-10 pl25 pt13">
            <i
              class="md-icon material-icons"
              style="color: #b3b3b3; cursor: pointer;"
              title="Delete"
              @click="deleteCustomer"
              >delete_sweep</i
            >
          </div>
        </div>

        <!-- TABLE -->
        <div
          class="md-layout-item md-size-100 table-customer"
          style="padding: 0;"
        >
          <div class="divHeadList">
            <div style="width: 6%;">
              <label class="-mkt-checkbox-container">
                <input
                  type="checkbox"
                  v-model="checkedCustomerAll"
                  @click="selectedCheckedAllCustomer()"
                />
                <span class="-mkt-checkbox"></span>
              </label>
            </div>
            <div style="width: 11%;">Code</div>
            <div style="width: 58%;">Cus. Name</div>
            <!-- <div style="width: 17%;" class="-text-center">Effective Date</div> -->
            <div style="width: 25%;" class="-text-center">Create Date</div>
          </div>

          <div class="divBodyList" :class="mode === 'ADD' ? 'calHeight' : ''">
            <div
              v-show="tableCustomer.length === 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center; font-size: 14px;"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray'"
              v-for="(item, rIndex) in tableCustomer"
              :key="rIndex"
            >
              <div style="width: 6%;">
                <label class="-mkt-checkbox-container">
                  <input
                    type="checkbox"
                    v-model="checkedCustomer"
                    :value="item.cus_code"
                    @click="selectedCheckedCustomer(item.cus_code)"
                  />
                  <span class="-mkt-checkbox"></span>
                </label>
              </div>
              <div style="width: 11%;">{{ item.cus_code }}</div>
              <div
                style="width: 58%;"
                :title="item.cus_name_th"
                class="nowrap-title -font-kanit"
              >
                {{ item.cus_name_th }}
              </div>
              <!-- <div style="width: 17%;" class="-text-center">
                <md-field class="custom-input -table">
                  <md-input
                    type="text"
                    placeholder="dd-mm-yyyy"
                    ref="effDate"
                    v-model="item.effective_date"
                    @keypress.native="isNumber(rIndex, this)"
                    @focus.native="$event.target.select()"
                    @keyup.native="
                      customFormatDate(rIndex, item.effective_date)
                    "
                  ></md-input>
                </md-field>
              </div> -->
              <div style="width: 25%;" class="-text-center">
                {{ formatDateDMY(item.c_date, 2) }}
              </div>
            </div>
          </div>

          <div class="footer-table">
            number of lines in page ({{ tableCustomer.length }})
          </div>
        </div>
      </div>

      <!-- DIALOG ALEART SEARCH -->
      <div :class="showDialogAlert ? 'bg-backdrop-bookprice' : ''"></div>
      <md-dialog
        :md-active.sync="showDialogAlert"
        class="mkt-ops -main-font volumepricing dialog-alert h60"
        :md-click-outside-to-close="false"
      >
        <md-dialog-title>Alert Message</md-dialog-title>
        <div class="layout-dialog">
          <div class="dialog-content">
            <div style="font-weight: bold; width: 20%;">
              Lost product : &ensp;
            </div>
            <div style="width: 80%;" class="scrollbar">
              {{ alertProductLost }}
            </div>
          </div>
          <div class="dialog-content -conditions">
            <div class="title" style="width: 100%;">Check conditions</div>
            <div style="width: 100%;">
              <ul>
                <li>Customer code ที่มีสถานะเป็น Inactive จะไม่นำมาแสดง</li>
                <li>
                  Customer code ไม่ได้อยู่ในกลุ่มลูกค้า MT หรือ กลุ่มลูกค้า MTT
                </li>
              </ul>
            </div>
          </div>
        </div>
        <md-dialog-actions class="-action">
          <md-button
            class="md-primary -confirm"
            @click="showDialogAlert = false"
            >OK</md-button
          >
        </md-dialog-actions>
      </md-dialog>

      <md-dialog-actions>
        <md-button class="-cancel" @click="onClickCancel()">CANCEL</md-button>
        <md-button class="-confirm" @click="onClickConfirm()">SAVE</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ contentSnackbar }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>

    <dialog-confirm
      :show="showDialogConfirm"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>
  </div>
</template>

<script>
import GlobalService from "@/services/global_function";
import BookpriceService from "@/services/bookprice";
import DialogConfirm from "./../../shared/dialog-confirm";
import moment from "moment-timezone";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
const simulateAsyncOperation = (fn) => {
  setTimeout(fn, 2000);
};

export default {
  name: "dialog-group-book",

  components: {
    DialogConfirm,
    Treeselect,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      required: false,
    },
    dataCustomer: {
      type: Object,
      required: true,
    },
    optionsBookType: {
      type: Array,
      required: true,
    },
    // genBookCode: {
    //   type: String,
    //   required: false
    // }
  },

  data() {
    return {
      valueDesciption: "",
      // selectedCustomer: [],
      optionsCustomer: [],
      dataHeadCustomer: [],
      tableCustomer: [],
      checkedCustomerAll: false,
      checkedCustomer: [],
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      contentSnackbar: "",
      showDialogConfirm: false,
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      checkEvent: "",
      valueTree: [],
      optionsTreeview: [],
      valueConsistsOf: "LEAF_PRIORITY",
      bookCode: "",
      // descLabel: "",
      headOffice: "",
      // valueCustomer: [],
      // optionsCustomer: [],
      dataToken: {},
      checkDataDelete: [],
      showDialogAlert: false,
      alertProductLost: "",
      selectedBookType: [],
    };
  },

  watch: {
    show() {
      if (this.show) {
        this.dataToken = this.$jwt.decode(localStorage.getItem("token"));

        if (this.mode === "EDIT") {
          // console.log("this.dataHeadCustomer ==>", this.dataHeadCustomer);
          this.dataHeadCustomer = JSON.parse(JSON.stringify(this.dataCustomer));
          this.tableCustomer = this.dataHeadCustomer.cust_in_group;
          this.tableCustomer.sort((a, b) => (a.cus_code > b.cus_code ? 1 : -1));

          this.bookCode = this.dataHeadCustomer.code;
          this.valueDesciption = this.dataHeadCustomer.desc;
          this.headOffice = this.dataHeadCustomer.parrent_code;

          // this.dataHeadCustomer.booktype = "B";
          let key = this.optionsBookType.findIndex((item) => {
            return this.dataHeadCustomer.booktype === item.code;
          });

          // this.selectedBookType = {
          //   _id: "64804436681a2a09b316b0bb",
          //   code: "B",
          //   title: "Sales Ops",
          // };
          this.selectedBookType = this.optionsBookType[key];

          for (let i = 0; i < this.tableCustomer.length; i++) {
            this.tableCustomer[i].effective_date =
              this.tableCustomer[i].effective_date === ""
                ? ""
                : this.formatDateDMY(this.tableCustomer[i].effective_date, 1);

            // this.valueTree.push(this.tableCustomer.cust_in_group[i].cus_code);
          }
        } else {
          //CREATE
          this.dataHeadCustomer = [];
          this.tableCustomer = [];
          // this.bookCode = this.genBookCode;
        }
        // this.optionsCustomer = JSON.parse(JSON.stringify(this.dataCustomer));
        // console.log("this.optionsCustomer ==>", this.optionsCustomer);
        // this.getCustomer();
        // BookpriceService.makeDataTableCustomer().then(response => {
        //   this.tableCustomer = response;
        // });
      }
    },
  },

  methods: {
    isNumber(index, event) {
      event = event ? event : window.event;
      // let value_input = event.target.value;
      if (
        // value_input.split("-") &&
        // value_input.split("-").length === 3 &&
        event.target.value.length > 9
      ) {
        // this.tableCustomer[index].effective_date = value_input;
        event.preventDefault();
        return false;
      }

      //-- START Compare Date --//
      let nowDate = moment(new Date()).format("DD-MM-YYYY");
      let nowDay = nowDate.split("-")[0];
      let nowMonth = nowDate.split("-")[1];
      let nowYear = nowDate.split("-")[2];

      setTimeout(() => {
        let value_input = this.$refs.effDate[index].value;
        let new_value = value_input.substring(0, value_input.length - 1);

        let effDay = value_input.split("-")[0];
        let effMonth = value_input.split("-")[1];
        let effYear = value_input.split("-")[2];

        let check = false;
        //---------- CHECK DATE ----------//
        // if (nowDay.length === 1) {
        //   if (parseInt(ed_first) < parseInt(nd_first)) {
        //     check = true;
        //     this.tableCustomer[index].effective_date = "";
        //     // event.preventDefault();
        //     // return false;
        //   }
        // } else if (nowDay.length === 2) {
        // let nd_first = nowDay.substring(0, 1);
        // let ed_first = effDay.substring(0, 1);
        // let nd_second = nowDay.substring(1, 2);
        // let ed_second = effDay ? effDay.substring(1, 2) : 0;

        // if (parseInt(ed_first) < parseInt(nd_first)) {
        //   check = true;
        //   this.tableCustomer[index].effective_date = "";
        //   // event.preventDefault();
        //   // return false;
        // } else if (
        //   parseInt(ed_first) < parseInt(nd_first) &&
        //   parseInt(ed_second) < parseInt(nd_second)
        // ) {
        //   check = true;
        //   this.tableCustomer[index].effective_date = new_value;
        //   // event.preventDefault();
        //   // return false;
        // }
        // }

        //---------- CHECK MONTH ----------//
        // if (value_input.length === 4 || value_input.length === 5) {
        //   let nm_first = nowMonth.substring(0, 1);
        //   let em_first = effMonth ? effMonth.substring(0, 1) : 0;
        //   let nm_second = nowMonth.substring(1, 2);
        //   let em_second = effMonth ? effMonth.substring(1, 2) : 0;

        //   if (effMonth && parseInt(em_first) < parseInt(nm_first)) {
        //     check = true;
        //     this.tableCustomer[index].effective_date = new_value;
        //   }
        // else if (effMonth && parseInt(em_second) < parseInt(nm_second)) {
        //   check = true;
        //   this.tableCustomer[index].effective_date = new_value;
        // }
        // }

        //---------- CHECK YEAR ----------//
        if (value_input.length > 6) {
          let ny_first = nowYear.substring(0, 1);
          let ey_first = effYear ? effYear.substring(0, 1) : 0;
          let ny_second = nowYear.substring(1, 2);
          let ey_second = effYear ? effYear.substring(1, 2) : 0;
          let ny_third = nowYear.substring(2, 3);
          let ey_third = effYear ? effYear.substring(2, 3) : 0;
          let ny_fourth = nowYear.substring(3, 4);
          let ey_fourth = effYear ? effYear.substring(3, 4) : 0;

          if (
            (effYear && parseInt(ey_first) < parseInt(ny_first)) ||
            parseInt(ey_second) < parseInt(ny_second) ||
            parseInt(ey_third) < parseInt(ny_third) ||
            parseInt(ey_fourth) < parseInt(ny_fourth)
          ) {
            check = true;
            this.tableCustomer[index].effective_date = new_value;
          }
        }

        if (
          (parseInt(effYear) >= parseInt(nowYear) &&
            parseInt(effMonth) < parseInt(nowMonth)) ||
          (parseInt(effYear) >= parseInt(nowYear) &&
            parseInt(effMonth) === parseInt(nowMonth) &&
            parseInt(effDay) < parseInt(nowDay))
        ) {
          check = true;
          this.tableCustomer[index].effective_date = "";
        }

        if (check) {
          this.contentSnackbar =
            "Effective Date must be greater than or equal to the current date.";
          this.showSnackbar = true;
          return;
        }
      }, 0);
      //-- END Compare Date --//

      var charCode = event.which ? event.which : event.keyCode;
      if (charCode >= 48 && charCode <= 57) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    },
    formatDateDMY(date, type) {
      if (date === undefined) {
        return "";
      }
      let format = type === 1 ? "DD-MM-YYYY" : "DD-MM-YYYY HH:mm:ss";
      return GlobalService.formatDate(date, format);
    },
    customLabel({ code, title }) {
      return `${code} : ${title}`;
    },
    setDataBookType(selectedOption) {
      this.selectedBookType = selectedOption;
    },
    clearAll() {
      this.selectedBookType = [];
    },
    customFormatDate(index, effective_date) {
      if (
        effective_date &&
        (effective_date.length === 2 || effective_date.length === 5)
      ) {
        this.tableCustomer[index].effective_date = effective_date + "-";
      }
    },
    checkLength(event) {
      if (event.target.value.length > 100) {
        event.preventDefault();
        return false;
      }
    },
    onClickCancel() {
      this.checkEvent = "cancel";
      this.contentDialog = "Are you sure you want to cancel changes ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    onClickConfirm() {
      if (this.valueDesciption.trim() === "") {
        this.contentSnackbar = "Please input Description.";
        this.showSnackbar = true;
        return;
      }
      // else if (this.tableCustomer.length === 0) {
      //   this.contentSnackbar = "Please add data customer in group.";
      //   this.showSnackbar = true;
      //   return;
      // }

      this.checkEvent = "confirm";
      this.contentDialog = "Are you sure you want to save ?";
      this.confirmText = "SAVE";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    // getCustomer() {
    //   BookpriceService.getCustomer().then(response => {
    //     response.sort((a, b) => (a.code > b.code ? 1 : -1));
    //     for (let i = 0; i < response.length; i++) {
    //       this.optionsCustomer.push({
    //         id: response[i].code,
    //         label: response[i].title_th,
    //         title: response[i].title,
    //         numberInGroup: response[i].numberInGroup
    //       });
    //     }
    //   });
    // },
    loadOptions({ action, searchQuery, callback }) {
      let self = this;
      if (action === ASYNC_SEARCH) {
        if (searchQuery.length > 1) {
          if (searchQuery.trim().split(" ").length > 470) {
            callback(null, []);
            self.contentSnackbar = "Search limit of 470 customer code.";
            self.showSnackbar = true;
            return;
          } else {
            simulateAsyncOperation(() => {
              let datas = {
                keyword: searchQuery,
                data_delete: this.checkDataDelete,
                limit: 9999,
                // all: true
              };

              BookpriceService.getCustomer(datas)
                .then((response) => {
                  this.optionsTreeview = response.data;

                  if (response.message.length > 0) {
                    self.alertProductLost = "";
                    let length = response.message.length - 1;
                    response.message.forEach(function(value, key) {
                      self.alertProductLost +=
                        key == length ? value : value + ", ";
                    });
                    self.showDialogAlert = true;

                    if (self.optionsTreeview.length >= 1) {
                      let input_search = self.$refs.customer;
                      let real_input = input_search.$el.querySelector(
                        ".vue-treeselect__input"
                      );
                      real_input.value = "";
                    }
                  }

                  // setTimeout(function() {
                  //   if (self.optionsTreeview.length >= 1) {
                  //     let input_search = self.$refs.customer;
                  //     let real_input = input_search.$el.querySelector(
                  //       ".vue-treeselect__input"
                  //     );
                  //     real_input.value = "";
                  //   }
                  // }, 2000);

                  let codeSearch = searchQuery.trim() !== "" ? searchQuery : "";
                  let splitText = codeSearch.split(" ");
                  let checkPaste = true;
                  for (let i = 0; i < splitText.length; i++) {
                    let checkInt = /^-{0,1}\d+$/.test(splitText[i]);
                    if (!checkInt) {
                      checkPaste = false;
                      continue;
                    }
                  }

                  if (checkPaste && splitText.length > 1) {
                    for (let i = 0; i < response.data.length; i++) {
                      let key = this.tableCustomer.findIndex((item) => {
                        return response.data[i].id === item.cus_code;
                      });

                      if (key === -1) {
                        this.valueTree.push(response.data[i].id);
                        this.tableCustomer.push({
                          cus_code: response.data[i].id,
                          cus_name_th: response.data[i].label,
                        });
                      }
                    }
                  }

                  if (self.tableCustomer.length > 0) {
                    self.valueTree = [];
                    response.data.forEach(function(value, key) {
                      for (let i = 0; i < self.tableCustomer.length; i++) {
                        let key = self.tableCustomer.findIndex((item) => {
                          return value.id === item.cus_code;
                        });

                        if (
                          key !== -1 &&
                          self.valueTree.indexOf(value.id) == -1
                        ) {
                          self.valueTree.push(value.id);
                        }
                      }
                    });
                  }

                  callback(null, self.optionsTreeview);
                })
                .catch();
            });
          }
        } else {
          callback(null, []);
        }
      }
    },
    onOpenTreeview() {
      // console.log("-- onOpenTreeview --", this.valueTree);
    },
    openOnSelectTreeview(node) {
      if (this.tableCustomer.length > 0) {
        for (let i = 0; i < this.tableCustomer.length; i++) {
          let key = this.tableCustomer.findIndex((item) => {
            return node.id === item.cus_code;
          });

          if (key === -1) {
            this.tableCustomer.push({
              cus_code: node.id,
              cus_name_th: node.label,
            });
          }
        }
      } else {
        this.tableCustomer.push({
          cus_code: node.id,
          cus_name_th: node.label,
        });
      }
    },
    onDeSelectTreeview(node) {
      let key = this.tableCustomer.findIndex((item) => {
        return node.id === item.cus_code;
      });
      if (key !== -1) {
        this.tableCustomer.splice(key, 1);
      }

      let index = this.valueTree.findIndex((item) => {
        return node.id === item.id;
      });
      if (index !== -1) {
        this.valueTree.splice(index, 1);
      }
    },
    // customLabelCustomer({ code, title_th }) {
    //   return `${code} : ${title_th}`;
    // },
    selectedCheckedAllCustomer() {
      this.checkedCustomer = [];
      if (!this.checkedCustomerAll) {
        for (let itemCode in this.tableCustomer) {
          this.checkedCustomer.push(this.tableCustomer[itemCode].cus_code);
        }
      }
    },
    selectedCheckedCustomer(cus_code) {
      if (this.checkedCustomer.indexOf(cus_code) == -1) {
        this.checkedCustomer.push(cus_code);
      } else {
        this.checkedCustomer.splice(this.checkedCustomer.indexOf(cus_code), 1);
      }

      if (this.checkedCustomer.length !== this.tableCustomer.length) {
        this.checkedCustomerAll = false;
      } else {
        this.checkedCustomerAll = true;
      }
    },
    // addDataTable(selectedOption) {
    //   if (this.tableCustomer.length > 0) {
    //     for (let i = 0; i < this.tableCustomer.length; i++) {
    //       let key = this.tableCustomer.findIndex(item => {
    //         return selectedOption.code === item.code;
    //       });

    //       if (key === -1) {
    //         this.tableCustomer.push(selectedOption);
    //       }
    //     }
    //   } else {
    //     this.tableCustomer.push(selectedOption);
    //   }

    //   let key = this.optionsCustomer.findIndex(item => {
    //     return selectedOption.code === item.code;
    //   });
    //   this.optionsCustomer.splice(key, 1);
    //   this.selectedCustomer = [];

    //   // document.getElementsByClassName("multiselect__single")[0].style.display =
    //   //   "none";
    //   // document.getElementsByClassName("multiselect__input")[0].style.width =
    //   //   "100%";
    // },
    deleteCustomer() {
      if (this.checkedCustomer.length === 0) {
        this.contentSnackbar = "Please select data.";
        this.showSnackbar = true;
        return;
      }

      this.checkEvent = "delete";
      this.contentDialog = "Are you sure you want to delete ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    onConfirm() {
      if (this.checkEvent === "delete") {
        for (let i = 0; i < this.checkedCustomer.length; i++) {
          this.checkDataDelete.push(this.checkedCustomer[i]);

          let key = this.tableCustomer.findIndex((item) => {
            return this.checkedCustomer[i] === item.cus_code;
          });
          // this.optionsCustomer.push(this.tableCustomer[key]);
          // this.optionsCustomer.sort((a, b) => (a.code > b.code ? 1 : -1));
          this.tableCustomer.splice(key, 1);

          let index = this.valueTree.indexOf(this.checkedCustomer[i]);
          this.valueTree.splice(index, 1);
        }
      } else if (this.checkEvent === "cancel") {
        this.tableCustomer = {};
        this.valueTree = [];
        this.checkDataDelete = [];
        this.valueDesciption = "";
        this.bookCode = "";
        this.$emit("cancel");
      } else if (this.checkEvent === "confirm") {
        let dataCustInGroup = [];
        for (let i = 0; i < this.tableCustomer.length; i++) {
          //Set Format Eff Date
          let effDate = this.tableCustomer[i].effective_date
            ? moment(this.tableCustomer[i].effective_date, "DD-MM-YYYY").format(
                "YYYY-MM-DD HH:mm:ss"
              )
            : "";

          //Set Array cust_in_group
          dataCustInGroup.push({
            cus_code: this.tableCustomer[i].cus_code,
            cus_name_th: this.tableCustomer[i].cus_name_th,
            status: "Active",
            effective_date: effDate,
            // c_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
            c_date:
              this.tableCustomer[i].c_date &&
              this.tableCustomer[i].c_date !== undefined
                ? moment(
                    this.tableCustomer[i].c_date,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("YYYY-MM-DD HH:mm:ss")
                : moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          });
        }

        //-- DATA FOR SAVE --//
        let datas = {
          _id: this.dataHeadCustomer._id ? this.dataHeadCustomer._id : "",
          code: this.dataHeadCustomer.code ? this.dataHeadCustomer.code : "",
          desc: this.valueDesciption,
          u_user: this.dataToken.code,
          c_date: this.dataHeadCustomer.c_date
            ? this.dataHeadCustomer.c_date
            : moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          u_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          parrent_code: this.dataHeadCustomer.parrent_code
            ? this.dataHeadCustomer.parrent_code
            : "",
          status: this.dataHeadCustomer.status
            ? this.dataHeadCustomer.status
            : "",
          customer_channel_code: "200",
          item_in_group: [],
          cust_in_group: dataCustInGroup,
          booktype: this.selectedBookType.code,
        };
        BookpriceService.saveGroupbook(datas).then((response) => {
          this.dataHeadCustomer = {};
          this.tableCustomer = [];
          this.valueTree = [];
          this.checkDataDelete = [];
          this.valueDesciption = "";
          this.bookCode = "";
          this.$emit("confirm");
        });
      }
      this.clearData();
      this.showDialogConfirm = false;
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    clearData() {
      // this.valueDesciption = "";
      this.selectedCustomer = [];
      this.checkedCustomerAll = false;
      this.checkedCustomer = [];
      // this.descLabel = "";
      this.headOffice = "";
      this.selectedBookType = [];
    },
  },
};
</script>

<style lang="scss">
.bookprice-dialog-group-book,
.bookprice-dialog-change-price,
.bookprice-dialog-filter-product,
.bookprice-dialog-compare-customer,
.bookprice-dialog-import-file,
.bookprice-dialog-delete-file,
.bookprice-dialog-share-file {
  width: 80%;
  height: 85%;
  max-height: 85% !important;
  transform: unset !important;
  top: 7% !important;
  left: 10% !important;
  font-weight: 400 !important;

  .md-dialog-title {
    font-size: 18px;
    font-weight: 700;
    padding: 24px 30px 0;
  }

  .dialog-content {
    padding: 0 30px;

    .md-layout-item {
      &.pl25 {
        padding-left: 25px;
      }
      &.pr25 {
        padding-right: 25px;
      }
      &.prl25 {
        padding: 0 25px;
      }
      &.pt13 {
        padding-top: 13px;
      }
      .pt10 {
        padding-top: 10px;
      }
      .pb10 {
        padding-bottom: 10px;
      }

      .-label {
        margin-bottom: 10px;
      }

      .custom-input {
        margin: 10px 0px 10px 0px;
        padding-top: unset;
        width: 100%;
        border-radius: 3px;
        min-height: 36px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
          0 1px 1px -2px rgba(0, 0, 0, 0);

        .md-icon {
          margin-left: 10px;
          margin-top: 7px;
          color: rgba(0, 0, 0, 0.54);
        }

        .md-input {
          height: 36px;
          margin-left: 7px;
          font-family: kanit;
          font-weight: 300;
          padding: 0 8px;
          font-size: 14px;
        }

        &.md-field > .md-icon:after,
        &.md-field:after,
        &.md-field:before {
          content: none;
        }

        &.-table {
          width: 85%;
          margin: auto;
          height: 25px;
          min-height: 25px !important;
          background: white;

          .md-input {
            width: 100%;
            margin: 0px;
            text-align: center;
            height: 25px;
            min-height: 25px !important;
          }
        }
      }
    }

    .table-customer {
      .divBodyList {
        height: calc(85vmin - 305px);

        &.calHeight {
          height: calc(85vmin - 325px);
        }
      }
    }
  }

  .md-dialog-actions {
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding: 8px 30px 15px 30px;

    .-cancel {
      color: #a8a8a8 !important;
      font-weight: 700;
      font-size: 16px;
    }

    .-confirm {
      color: #3f51b5;
      font-weight: 700;
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .multiselect {
    font-weight: 300;

    .z-index-top {
      z-index: 10;
    }

    margin: 5px 0px;

    &.multiselect--disabled .multiselect__tags .multiselect__single {
      width: 95% !important;
    }

    .multiselect__single,
    .multiselect__input {
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 0px;

      div {
        display: flex;
        width: 100%;

        .-delete {
          width: 5%;
          margin: 0px 5px;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }
  }
}

.volumepricing.dialog-alert.h60 {
  .dialog-content .scrollbar {
    overflow-y: scroll;
    height: calc(60vmin - 220px);

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }
}
.bg-backdrop-bookprice {
  background: rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 15;
  top: 0;
  left: 0;
}
</style>
